import Listagem from "./Listagem";
import { ModalDetalheTituloProvider } from "../ModalDetalheTituloContext";

export default function ListarTodas() {
    return (
        <>
            <ModalDetalheTituloProvider>
                <Listagem />
            </ModalDetalheTituloProvider>
        </>
    )
}